import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component that resets scroll position on route changes.
 * Industry-standard pattern used by GitHub, Twitter, LinkedIn, etc.
 *
 * This component:
 * - Instantly scrolls to top on navigation (no animation)
 * - Temporarily disables smooth scroll to prevent visible animation
 * - Uses useLayoutEffect to run synchronously before browser paint
 * - Works with React Router's location changes
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Temporarily disable smooth scroll behavior
    const htmlElement = document.documentElement;
    const originalBehavior = htmlElement.style.scrollBehavior;
    htmlElement.style.scrollBehavior = "auto";

    // Instant scroll to top
    window.scrollTo(0, 0);

    // Restore smooth scroll behavior after scroll completes
    // Use setTimeout to ensure it happens after the scroll
    setTimeout(() => {
      htmlElement.style.scrollBehavior = originalBehavior;
    }, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
